export function coverDateModePatch(
  next,
  { mode, year, dateFrom, dateTo },
  now = new Date()
) {
  if (next === mode) return null;

  const y = now.getFullYear();
  const pad = (n) => String(n).padStart(2, "0");
  const patch = { coverDateMode: next };

  if (next === "range") {
    const a = String(dateFrom || "").trim();
    const b = String(dateTo || "").trim();

    patch.coverDateFrom = a || b || `01.01.${y}`;
    patch.coverDateTo = b || a || `02.02.${y}`;
  } else if (next === "year") {
    patch.coverYear = /^\d{4}$/.test(year || "")
      ? year
      : String(y);
  } else if (next === "date") {
    patch.coverYear = /^\d{2}\.\d{2}\.\d{4}$/.test(year || "")
      ? year
      : `${pad(now.getDate())}.${pad(now.getMonth() + 1)}.${y}`;
  }

  // «Без даты» скрывает дату, сохраняя значения для возврата.
  return patch;
}